import {
  Combobox,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
} from "components/ui/combobox";
import { SingleFilterTrigger } from "components/NewAdvancedSearch/filters/SingleFilterTrigger";
import { useSelectFilterOptions } from "components/NewAdvancedSearch/filters/useSelectFilterOptions";

const initialValue = {
  op: "is",
  value: null,
};

export function SingleSelectFilter({ descriptor, value, onChange }) {
  const { data, queryFn, key, props } = descriptor;
  const { isAsync, options, isFetching, onInputValueChange } =
    useSelectFilterOptions({ data, queryFn, queryKey: key, props });

  const current = value ?? initialValue;
  const selected = current.value ?? null;

  const handleChange = next => onChange({ ...current, value: next });

  const labelFor = o => o.name;

  return (
    <Combobox
      items={options}
      value={selected}
      filter={isAsync ? null : undefined}
      onValueChange={handleChange}
      onInputValueChange={isAsync ? onInputValueChange : undefined}
      itemToStringLabel={o => o.name}
      isItemEqualToValue={(o, v) => o.id === v?.id}
    >
      <SingleFilterTrigger labelFor={labelFor} />
      <ComboboxContent>
        <ComboboxInput showTrigger={false} placeholder="Search" />
        <ComboboxEmpty>
          {isFetching ? "Loading…" : "No options found."}
        </ComboboxEmpty>
        <ComboboxList>
          {item => (
            <ComboboxItem key={item.id} value={item}>
              {item.name}
            </ComboboxItem>
          )}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
